import React from 'react';
import { Star } from 'lucide-react';

const TestimonialCard: React.FC = () => {
  return (
    <div className="bg-gradient-to-b from-[#f9fff5] to-white rounded-2xl p-10 flex flex-col items-center justify-center border border-gray-100 shadow-sm min-h-[500px]">
      <div className="w-24 h-24 rounded-full bg-gray-200 border-4 border-[#7AEA53] mb-6 overflow-hidden">
        <img 
          src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg" 
          alt="Mariana Costa"
          className="w-full h-full object-cover"
        />
      </div>
      
      <p className="text-xl text-[#103541] text-center leading-relaxed mb-6 max-w-[400px]">
        "Conseguimos reduzir 85% do tempo gasto com tarefas manuais e agora focamos no que realmente importa: análises estratégicas."
      </p>
      
      <div className="font-semibold text-lg text-[#103541]">Mariana Costa</div>
      <div className="text-[#2E6173] mb-4">Coordenadora Fiscal, TechCorp</div>
      
      <div className="flex text-[#7AEA53]">
        {[...Array(5)].map((_, i) => (
          <Star key={i} fill="#7AEA53" />
        ))}
      </div>
    </div>
  );
};

export default TestimonialCard;